<dashboard-dialog-frame [header]='header' [actions]='actions' [dialogRef]='dialogRef' icon='far fa-question-circle'>

	<div style="padding: .7em .5em;">

		<p style="white-space: pre-wrap;">{{ message }}</p>

		@if(bullets.length) {
		<div class="confirmation-dialog-bullets-container">
			<ul>
				@for (bullet of bullets; track $index) {
				<li>{{ bullet }}</li>
				}
			</ul>
		</div>
		}

	</div>

</dashboard-dialog-frame>